<template>
  <div>
    <Header></Header>
    <main id="content" role="main">
      <!-- Hero Section -->
      <div class="bg-primary bg-img-hero">
        <div class="container space-2 space-lg-3">
          <div class="w-lg-65 text-center mx-lg-auto">
            <span
              class="
                badge badge-soft-light badge-pill
                font-size-1
                py-3
                px-4
                mb-3
              "
              >客户案例</span
            >
            <h1 class="text-white mb-0">{{ caseDetail.title }}</h1>
          </div>
        </div>
      </div>
      <!-- End Hero Section -->

      <!-- Content Section -->
      <div class="container space-2 space-lg-0">
        <div class="row">
          <!-- 侧边栏 -->

          <!-- 内容 -->
          <div class="col-lg-24 space-lg-1">
            <div class="pl-lg-4 addimg" v-html="caseDetail.content"></div>
          </div>
        </div>
      </div>
      <!-- End Content Section -->

      <!-- Sticky Block End Point -->
      <div id="stickyBlockEndPoint"></div>

      <!-- Testimonials -->
      <div class="bg-light">
        <div class="container space-1 space-md-2 space-lg-1">
          <div class="w-lg-75 mx-lg-auto pt-5">
            <!-- SVG Quote -->
            <figure class="mx-auto text-center mb-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="40px"
                height="40px"
                viewBox="0 0 8 8"
                style="enable-background: new 0 0 8 8"
                xml:space="preserve"
              >
                <path
                  fill="#377dff"
                  d="M3,1.3C2,1.7,1.2,2.7,1.2,3.6c0,0.2,0,0.4,0.1,0.5c0.2-0.2,0.5-0.3,0.9-0.3c0.8,0,1.5,0.6,1.5,1.5c0,0.9-0.7,1.5-1.5,1.5
                C1.4,6.9,1,6.6,0.7,6.1C0.4,5.6,0.3,4.9,0.3,4.5c0-1.6,0.8-2.9,2.5-3.7L3,1.3z M7.1,1.3c-1,0.4-1.8,1.4-1.8,2.3
                c0,0.2,0,0.4,0.1,0.5c0.2-0.2,0.5-0.3,0.9-0.3c0.8,0,1.5,0.6,1.5,1.5c0,0.9-0.7,1.5-1.5,1.5c-0.7,0-1.1-0.3-1.4-0.8
                C4.4,5.6,4.4,4.9,4.4,4.5c0-1.6,0.8-2.9,2.5-3.7L7.1,1.3z"
                />
              </svg>
            </figure>
            <!-- End SVG Quote -->

            <!-- Blockquote -->
            <div class="text-center mb-5">
              <blockquote class="h2 font-weight-normal">
                {{ caseDetail.evaluation }}
              </blockquote>
            </div>
            <!-- End Blockquote -->

            <!-- Reviewer -->
            <div class="w-lg-50 text-center mx-lg-auto">
              <h4 class="mb-00">{{ caseDetail.customerName }}</h4>
              <small class="text-muted">{{ caseDetail.customerCompany }}</small>
            </div>
            <!-- End Reviewer -->
          </div>
        </div>
      </div>
      <!-- Testimonials -->

      <!-- Stories Section -->
      <div class="container space-1">
        <!-- Title -->
        <div class="w-md-80 w-lg-40 text-center mx-md-auto mb-5 mb-md-9">
          <h2>更多合作案例</h2>
        </div>
        <!-- End Title -->

        <div class="row">
          <div
            class="col-sm-6 col-md-4 mb-5"
            v-for="(item, index) in caselist"
            :key="index"
          >
            <!-- Card Info -->
            <div class="card h-100">
              <img
                class="card-img-top"
                :src="getImgUrl(item.big)"
                alt="Image Description"
              />
              <div class="card-body">
                <p class="mb-0">{{ item.title }}</p>
              </div>
              <div class="card-footer">
                <router-link
                  :to="{ path: '/casedetail', query: { id: item.contentId } }"
                  class="font-weight-bold"
                  >查看方案<i class="fas fa-angle-right fa-sm ml-1"></i
                ></router-link>
              </div>
            </div>
            <!-- End Card Info -->
          </div>

          <!-- <div class="col-sm-6 col-md-4 mb-5">
            <div class="card h-100">
              <img
                class="card-img-top"
                src="@/assets/img/480x320/002.png"
                alt="Image Description"
              />
              <div class="card-body">
                <p class="mb-0">山西某矿业公司三维可视化案例</p>
              </div>
              <div class="card-footer">
                <a class="font-weight-bold" href="case-4.html"
                  >查看方案<i class="fas fa-angle-right fa-sm ml-1"></i
                ></a>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-md-4 mb-5">
            <div class="card h-100">
              <img
                class="card-img-top"
                src="@/assets/img/480x320/003.png"
                alt="Image Description"
              />
              <div class="card-body">
                <p class="mb-0">山西移动某分公司合作项目</p>
              </div>
              <div class="card-footer">
                <a class="font-weight-bold" href="case-5.html"
                  >查看方案<i class="fas fa-angle-right fa-sm ml-1"></i
                ></a>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <!-- End Stories Section -->

      <!-- CTA Section -->
      <div class="bg-primary text-center bg-img-hero">
        <div class="container space-2">
          <div class="mb-5">
            <h3 class="h2 text-white">索取更多案例/解决方案请与商务经理联系</h3>
          </div>
          <router-link class="btn btn-light transition-3d-hover" to="/contact"
            >联系我们</router-link
          >
        </div>
      </div>
      <!-- End CTA Section -->
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/vendor/jquery/dist/jquery.min.js";
import "@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js";

import "@/assets/vendor/font-awesome/css/all.min.css";
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.css";
import "@/assets/vendor/fancybox/dist/jquery.fancybox.min.css";
import "@/assets/vendor/aos/dist/aos.css";
import "@/assets/css/theme.css";
import "@/assets/vendor/hs-header/dist/hs-header.min.js";
import "@/assets/vendor/hs-go-to/dist/hs-go-to.min.js";
import "@/assets/vendor/hs-unfold/dist/hs-unfold.min.js";
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.js";
import "@/assets/vendor/fancybox/dist/jquery.fancybox.min.js";
import "@/assets/vendor/appear.js";
import "@/assets/vendor/circles/circles.min.js";
import "@/assets/vendor/polifills.js";
import AOS from "aos";
// import 'aos/dist/aos.css'

// import 'bootstrap'
// import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@/assets/js/hs.core.js";
import "@/assets/js/hs.fancybox.js";

import "@/assets/js/hs.circles.js";
import "@/assets/vendor/hs-counter/dist/hs-counter.min.js";
import Header from "../components/header";
import Footer from "../components/footer";
import {
  getcontent,
  getsyres,
  getcaseDetail,
  getsycolumn,
  getsy,
} from "../request/index";
export default {
  components: {
    Header,
    Footer,
  },

  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
    $(document).ready(function () {
      //   console.log("ccccc",HSHeader)
      //   var header = new HSHeader($("#header")).init();

      // initialization of mega menu
      var megaMenu = new HSMegaMenu($(".js-mega-menu"), {
        desktop: {
          position: "left",
        },
      }).init();

      // initialization of unfold
      var unfold = new HSUnfold(".js-hs-unfold-invoker").init();

      // initialization of fancybox
      $(".js-fancybox").each(function () {
        var fancybox = $.HSCore.components.HSFancyBox.init($(this));
      });

      // initialization of circles
      $(".js-circle").each(function () {
        var circle = $.HSCore.components.HSCircles.init($(this));
      });

      //initialization of aos
      AOS.init({
        duration: 650,
        once: true,
      });
      // if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) document.write('<script src="@/assets/vendor/polifills.js"><\/script>');
      // initialization of go to
      $(".js-go-to").each(function () {
        var goTo = new HSGoTo($(this)).init();
      });
      $(".js-counter").each(function () {
        var counter = new HSCounter($(this)).init();
      });
    });
  },
  watch: {
    "$route.query.id": {
      handler(val) {
        if (val) {
          this.getDetail(val);
          this.getFirst();
          this.caselist = [];
        }
      },
    },
  },
  data() {
    return {
      caseDetail: {},
      leftObj: {},
      caselist: [],
    };
  },
  created() {
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id);
    }
    this.getFirst();
  },
  methods: {
    goTop(id) {
      this.getDetail(id);
    },
    //获取案例详情
    getDetail(id) {
      getcontent(id).then((res) => {
        console.log(354, res);

        this.caseDetail = res.data.content[0];
        if (this.caseDetail.fromuser) {
          getcaseDetail(this.caseDetail.fromuser).then((hs) => {
            this.leftObj = hs.data.content[0];
          });
        }
      });
    },
    // 获取当前栏目
    getFirst() {
      getsycolumn(0).then((res) => {
        let arr = res.data;
        arr.forEach((item) => {
          if (item.title == "客户案例") {
            getsycolumn(item.columnId).then((hs) => {
              let arr1 = hs.data;
              arr1.forEach((ts) => {
                if (ts.type == "用户为本，携手共进") {
                  this.columnId = ts.columnId;
                  this.getContent(ts.columnId);
                }
              });
            });
          }
        });
      });
    },
    // 获取内容
    getContent(id) {
      getsy(id).then((res) => {
        if (res.data.content.length > 0) {
          let arr = res.data.content;
          let z = 1;
          arr.forEach((item, index) => {
            if (item.contentId == this.$route.query.id) {
              return false;
            } else {
              if (z > 3) {
                return;
              } else {
                z = z + 1;
                item.showImgStatu = false;
                this.getSource(item, item.contentId, index, arr);
              }
            }
          });
        }
      });
    },
    // 获取内容资源资源
    getSource(obj, id, index, array) {
      getsyres(id).then((res) => {
        let arr = res.data;
        console.log(313, arr);
        if (arr && arr.length > 0) {
          arr.forEach((hs) => {
            obj[hs.keystring] = hs.fileId;
          });
        }
        this.caselist.push(obj);
        console.log(this.caselist);
      });
    },
    // 图片地址
    getImgUrl(id) {
      return process.env.NODE_URL + "api/files/getFileStream?fileId=" + id;
    },
  },
};
</script>

<style scoped>
.bg-img-hero {
  background: url("../assets/svg/components/abstract-shapes-5.svg") center;
}
.pb-5,
.py-5 {
  padding: 2rem 0 !important;
}
.text-dark {
  line-height: 1.6;
  color: #1e2022 !important;
}
.text-body {
  color: #677788 !important;
}
.mb-3 h4 {
  margin-bottom: 0.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.4;
}
.col-sm-12 h4 {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.4;
}
.col-sm-12 p {
  font-size: 0.875rem;
  color: #677788 !important;
}
#stickyBlockStartPoint {
  position: sticky !important;
  position: -webkit-sticky;
  top: 10px;
}
.pl-lg-4 .h3 {
  margin-bottom: 0.5rem;
  font-size: 1.3125rem;
  font-weight: 600;
  line-height: 1.4;
}
.pl-lg-4 p {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
}
.font-weight-normal {
  font-size: 1.875rem;
  line-height: 1.4;
}
.mx-lg-auto .mb-0 {
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.text-muted {
  font-weight: 400;
  color: #8c98a4 !important;
  line-height: 1.6;
}
a {
  text-decoration: none;
}
.mb-md-9 h2 {
  font-size: 1.875rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.card-body .mb-0 {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.6;
}
.card-body .mb-01 {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.6;
}
.mx-lg-auto .mb-00 {
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.4;
}
</style>


// WEBPACK FOOTER //
// src/components/casedetail.vue